var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4C14.2091 4 16 5.79086 16 8V9H17C18.1046 9 19 9.89543 19 11V18C19 19.1046 18.1046 20 17 20H7C5.89543 20 5 19.1046 5 18V11C5 9.89543 5.89543 9 7 9H8V8C8 5.79086 9.79086 4 12 4ZM17 10H7C6.48716 10 6.06449 10.386 6.00673 10.8834L6 11V18C6 18.5128 6.38604 18.9355 6.88338 18.9933L7 19H17C17.5128 19 17.9355 18.614 17.9933 18.1166L18 18V11C18 10.4872 17.614 10.0645 17.1166 10.0067L17 10ZM12 11C13.1046 11 14 11.8954 14 13C14 13.9316 13.3631 14.7144 12.501 14.9367L12.5 16.5C12.5 16.7761 12.2761 17 12 17C11.7239 17 11.5 16.7761 11.5 16.5L11.5 14.937C10.6374 14.715 10 13.9319 10 13C10 11.8954 10.8954 11 12 11ZM12 12C11.4477 12 11 12.4477 11 13C11 13.5523 11.4477 14 12 14C12.5523 14 13 13.5523 13 13C13 12.4477 12.5523 12 12 12ZM12 5C10.4023 5 9.09634 6.24892 9.00509 7.82373L9 8V9H15V8C15 6.40232 13.7511 5.09634 12.1763 5.00509L12 5Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.4ba5ff148a64d54f6baa3d18e2e9a05b.svg";
export { ForwardRef as ReactComponent };